import React, {Component, Fragment} from 'react';
import {Query} from 'react-apollo';
import {Redirect} from 'react-router';
import gql from 'graphql-tag';

import {SiteFooter} from '@homeaway/react-site-footer';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import HttpError from 'components/HttpError';
import LoadedPageContainer from './LoadedPageContainer';
import {triggerEdapPageView} from 'utils/edap';
import {getRedirect} from 'utils/redirects';

import {HomeRouteContext} from 'utils/context';
import {parse} from 'query-string';

const FULL_URL_REDIRECT_REGEXP = /^https?:\/\//;

export const query = gql`
    query brandCategories($sitename: String, $preview: Boolean) {
        translationsCollection(where: {site: $sitename}, preview: $preview) {
            items {
                home
                headerButton
                categories
                articles
                exploreArticles
                browseByCategory
                browseBySubcategory
                previous
                next
                expand
                collapse
                openMenu
                closeMenu
                copyLink
            }
        }
        homeCollection(where: {site: $sitename}, preview: $preview) {
            items {
                sys {
                    id
                }
                socialShare
            }
        }
        allCategories: categoryCollection(
            where: {site: $sitename}
            preview: $preview
        ) {
            items {
                name
                slug
                parentId
                path
                partition
                sys {
                    id
                }
            }
        }
    }
`;

class PageContainer extends Component {
    state = {
        params: this.props.match.params,
    };

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            triggerEdapPageView();
        }
    }

    render() {
        const {homeRoute, location, match, redirects, systemData} = this.props;
        const preview = parse(location.search).preview === 'true';
        const variables = {sitename: systemData.siteName, preview};
        const requestUrl = match.url;

        const redirect = getRedirect(homeRoute, requestUrl, redirects);
        const {
            footerData: {logo},
            ...rest
        } = this.props;

        if (redirect) {
            if (FULL_URL_REDIRECT_REGEXP.test(redirect)) {
                // throw a 414 error (URI Too Long) and let application.js handle the situation
                return <HttpError statusCode={414} message={redirect} />;
            }

            return <Redirect to={redirect} />;
        }

        return (
            <Fragment>
                <ScrollToTop {...location} />
                <HomeRouteContext.Provider value={homeRoute}>
                    <Query {...{query, variables}}>
                        {(response) => {
                            return (
                                <LoadedPageContainer
                                    {...{
                                        logo,
                                        response,
                                        ...this.state,
                                        ...rest,
                                        preview,
                                    }}
                                />
                            );
                        }}
                    </Query>
                </HomeRouteContext.Provider>
                <SiteFooter data={this.props.footerData} />
            </Fragment>
        );
    }
}

export default PageContainer;
